import { render, staticRenderFns } from "./formCreateEdition.vue?vue&type=template&id=8cf3d6b8"
import script from "./formCreateEdition.vue?vue&type=script&lang=js"
export * from "./formCreateEdition.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/重构-快递前端-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8cf3d6b8')) {
      api.createRecord('8cf3d6b8', component.options)
    } else {
      api.reload('8cf3d6b8', component.options)
    }
    module.hot.accept("./formCreateEdition.vue?vue&type=template&id=8cf3d6b8", function () {
      api.rerender('8cf3d6b8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/reverse/edition/components/form/formCreateEdition.vue"
export default component.exports